(function () {
  function setupCarousel(root) {
    if (!root || root.dataset.hceCarouselReady === 'true') return;
    var track = root.querySelector('[data-hce-related-track]');
    var prev = root.querySelector('[data-hce-related-prev]');
    var next = root.querySelector('[data-hce-related-next]');
    if (!track || !prev || !next) return;

    root.dataset.hceCarouselReady = 'true';

    function updateButtons() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollByPage(direction) {
      var firstItem = track.querySelector('.hce-related-grid__item');
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0) || 0;
      var itemStep = firstItem ? firstItem.getBoundingClientRect().width + gap : track.clientWidth;

      var itemsPerStep = 1;
      if (window.matchMedia('(min-width: 990px)').matches) {
        itemsPerStep = 4;
      } else if (window.matchMedia('(min-width: 750px)').matches) {
        itemsPerStep = 2;
      }

      var amount = itemStep * itemsPerStep;
      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByPage(-1); });
    next.addEventListener('click', function () { scrollByPage(1); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-hce-related-carousel]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();